import { getRequestSingle } from '../services/requestHandler';
import { CTData } from '../models/serialNumber';

export const getLatestSerialMstrCt = async (serialMstrId: string): Promise<CTData> => {
  const url = `rnd/GetLatestSerialMstrCt?serialMstrId=${encodeURIComponent(serialMstrId)}`;
  const response = await getRequestSingle<CTData>('GetLatestSerialMstrCt', url);
  return response;
};

export default getLatestSerialMstrCt;
